export default {
  createDeal: {
    automationAction: {
      key: 'create_deal',
      name: 'Cria negócio',
      attributeI18nKey: 'CREATE_DEAL',
    },
    automationActionType: {
      key: 'create_deal',
      label: 'CREATE_DEAL',
      inputType: 'textarea',
    },
  },
  c2s: {
    createLeadInC2s: {
      automationAction: {
        key: 'create_lead_in_c2s',
        name: 'C2S - Cria lead no C2S',
        attributeI18nKey: 'CREATE_LEAD_IN_C2S',
      },
      automationActionType: {
        key: 'create_lead_in_c2s',
        label: 'CREATE_LEAD_IN_C2S',
        inputType: null,
      },
    },
  },
  flexpro: {
    createInterestInFlexpro: {
      automationAction: {
        key: 'create_interest_in_flexpro',
        name: 'Flexpro - Cria interesse no Flexpro',
        attributeI18nKey: 'CREATE_INTEREST_IN_FLEXPRO',
      },
      automationActionType: {
        key: 'create_interest_in_flexpro',
        label: 'CREATE_INTEREST_IN_FLEXPRO',
        inputType: null,
      },
    },
  },
  pipefy: {
    attachLabelToDealInPipefy: {
      automationAction: {
        key: 'attach_label_to_deal_in_pipefy',
        name: 'Pipefy - Anexa etiqueta ao negócio',
        attributeI18nKey: 'ATTACH_LABEL_TO_DEAL_IN_PIPEFY',
      },
      automationActionType: {
        key: 'attach_label_to_deal_in_pipefy',
        label: 'ATTACH_LABEL_TO_DEAL_IN_PIPEFY',
        inputType: 'textarea',
      },
    },
  },
  piperun: {
    createOrUpdatePersonInPiperun: {
      automationAction: {
        key: 'create_or_update_person_in_piperun',
        name: 'Piperun - Cria ou atualiza pessoa no Piperun',
        attributeI18nKey: 'CREATE_OR_UPDATE_PERSON_IN_PIPERUN',
      },
      automationActionType: {
        key: 'create_or_update_person_in_piperun',
        label: 'CREATE_OR_UPDATE_PERSON_IN_PIPERUN',
        inputType: null,
      },
    },
    createOpportunityInPiperun: {
      automationAction: {
        key: 'create_opportunity_in_piperun',
        name: 'Piperun - Cria oportunidade no Piperun',
        attributeI18nKey: 'CREATE_OPPORTUNITY_IN_PIPERUN',
      },
      automationActionType: {
        key: 'create_opportunity_in_piperun',
        label: 'CREATE_OPPORTUNITY_IN_PIPERUN',
        inputType: 'textarea',
      },
    },
  },
  promentor: {
    createCustomerAndTicketInPromentor: {
      automationAction: {
        key: 'create_customer_and_ticket_in_promentor',
        name: 'PróMentor - Cria cliente e atendimento no PróMentor',
        attributeI18nKey: 'CREATE_CUSTOMER_AND_TICKET_IN_PROMENTOR',
      },
      automationActionType: {
        key: 'create_customer_and_ticket_in_promentor',
        label: 'CREATE_CUSTOMER_AND_TICKET_IN_PROMENTOR',
        inputType: null,
      },
    },
    assignConversationToPromentorPropertyUser: {
      automationAction: {
        key: 'assign_conversation_to_promentor_property_user',
        name: 'PróMentor - Consulta corretor angariador do imóvel e atribui à conversa',
        attributeI18nKey: 'ASSIGN_CONVERSATION_TO_PROMENTOR_PROPERTY_USER',
      },
      automationActionType: {
        key: 'assign_conversation_to_promentor_property_user',
        label:
          'ASSIGN_CONVERSATION_TO_PROMENTOR_PROPERTY_USER',
        inputType: null,
      },
    },
  },
  msys_imob: {
    createLeadInMsysImob: {
      automationAction: {
        key: 'create_lead_in_msys_imob',
        name: 'Msys Imob - Cria lead no Msys Imob',
        attributeI18nKey: 'CREATE_LEAD_IN_MSYS_IMOB',
      },
      automationActionType: {
        key: 'create_lead_in_msys_imob',
        label: 'CREATE_LEAD_IN_MSYS_IMOB',
        inputType: null,
      },
    },
  },
  via_imob: {
    createLeadInViaImob: {
      automationAction: {
        key: 'create_lead_in_via_imob',
        name: 'ViaImob - Cria lead no ViaImob',
        attributeI18nKey: 'CREATE_LEAD_IN_VIA_IMOB',
      },
      automationActionType: {
        key: 'create_lead_in_via_imob',
        label: 'CREATE_LEAD_IN_VIA_IMOB',
        inputType: null,
      },
    },
  },
  nido_imovel: {
    createLeadInNidoImovel: {
      automationAction: {
        key: 'create_lead_in_nido_imovel',
        name: 'NidoImovel - Cria lead no NidoImovel',
        attributeI18nKey: 'CREATE_LEAD_IN_NIDO_IMOVEL',
      },
      automationActionType: {
        key: 'create_lead_in_nido_imovel',
        label: 'CREATE_LEAD_IN_NIDO_IMOVEL',
        inputType: null,
      },
    },
  },
};
